import { User } from "firebase/auth";
import { createContext } from "react";

const AuthContext = createContext<{ user: User | null; entry_page: string }>({
  user: null,
  entry_page: "",
});

export default AuthContext;
